import Link from "@mui/material/Link";
import AccountVsProfile from "../../AccountVsProfile.jsx";
import {Alert, AlertTitle, Box, CardActionArea, CardHeader, FormControl, Radio, RadioGroup, Typography} from "@mui/material";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import FormControlLabel from "@mui/material/FormControlLabel";
import {useEffect, useState, useRef} from "react";
import {Crumbs} from "../../Crumbs.jsx";
import Grid from "@mui/material/Grid";
import { useAuth } from "../../Auth/AuthPage.jsx";
import TextField from "@mui/material/TextField";

import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import {copyToClipboard} from "../../Event.jsx";
import {validate} from "uuid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";


const BACKEND_HOST = process.env["REACT_APP_BACKEND_HOST"];
const calendarURL = (BACKEND_HOST, privateToken) => `${BACKEND_HOST}/events/ical?token=${privateToken}`;

const AccountPage = () => {
    const [accountVsProfileOpen, setAccountVsProfileOpen] = useState(false);
    const { user, loggedIn, currentUserProfile, loadCurrentUserProfile } = useAuth();
    const [snackBarOpen, setSnackBarOpen] = useState(false);
    const [snackBarMessage, setSnackBarMessage] = useState("");
    const [profileChanged, setProfileChanged] = useState(false);
    const [settings, setSettings] = useState({
        danceRole: "",
        visibility: "",
    });
    const [newProfileSettings, setNewProfileSettings] = useState({
        name: currentUserProfile?.name || "",
        instagram: currentUserProfile?.instagram || "",
    });
    const [token, setToken] = useState(null);
    const [uploading, setUploading] = useState(false);
    const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
    const [createProfileDialogOpen, setCreateProfileDialogOpen] = useState(false);
    const [newProfile, setNewProfile] = useState({
        name: "",
        instagram: ""
    });
    const [creatingProfile, setCreatingProfile] = useState(false);
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [confirmError, setConfirmError] = useState(null);
    const [editBioDialogOpen, setEditBioDialogOpen] = useState(false);
    const [bio, setBio] = useState(currentUserProfile?.bio || "");
    const [bioSaving, setBioSaving] = useState(false);
    const fileInputRef = useRef();
    
    const getSettings = () => {
        fetch(`${BACKEND_HOST}/preference/all`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
            }
        })
        .then(res => res.json())
        .then(data => setSettings(data));
    }

    useEffect(() => {
        getSettings();
        // Fetch user private settings from Strapi for calendar integration
        const fetchPrivateSettings = async () => {
            const res = await fetch(`${BACKEND_HOST}/users/me`, {
                method: "GET",
                headers: {
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                }
            });
            if (res.ok) {
                const data = await res.json();
                // Assume token is in data.privateToken
               
                if (validate(data.icalToken)) {
                    setToken(data.icalToken);
                } else {
                    setToken(false);
                }
            } else {
                setToken(false);
            }
        };
        fetchPrivateSettings();
        setNewProfileSettings({
            name: currentUserProfile?.name || "",
            instagram: currentUserProfile?.instagram || "",
        });
        setBio(currentUserProfile?.bio || "");
    }, [currentUserProfile]);

    const updateProfile = async (name, value) => {
        setProfileChanged(true)
        setNewProfileSettings(prev => ({ ...prev, [name]: value }));
    }

    const saveProfile = async () => {
        const payload = {
            "name": newProfileSettings.name,
            "instagram": newProfileSettings.instagram
        }
        await fetch(`${BACKEND_HOST}/user-profiles/${currentUserProfile.documentId}`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
            },
            body: JSON.stringify({ data: payload })
        })
        .then(res => {
            if (res.status !== 200) throw new Error("Failed to update setting")
            setProfileChanged(false)
            setSnackBarMessage(`Profile updated successfully.`);
            setSnackBarOpen(true);
        })
        .catch(err => console.error("Error updating setting:", err));
    }

    // Save a single setting to Strapi /api/user
    const updateSetting = async (name, value) => {
        const payload = { [name]: value };
        await fetch(`${BACKEND_HOST}/preference/set`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
            },
            body: JSON.stringify(payload)
        })
        .then(res => {
            if (res.status !== 200) throw new Error("Failed to update setting")
            setSettings(prev => ({ ...prev, [name]: value }));
            setSnackBarMessage(`Setting ${name} updated to ${value}.`);
            setSnackBarOpen(true);
            })
        .catch(err => console.error("Error updating setting:", err));
    };

    const handleImageChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setUploading(true);
        const formData = new FormData();
        formData.append("files", file);
        formData.append("ref", "api::user-profile.user-profile");
        formData.append("refId", currentUserProfile.id);
        formData.append("field", "pic");

        // Upload to Strapi media library
        const res = await fetch(`${BACKEND_HOST}/upload`, {
            method: "POST",
            headers: {
                "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
            },
            body: formData
        });
        // const data = await res.json();
        if (!res.ok) {
            setSnackBarMessage("Error updating profile image.");
            setSnackBarOpen(true);
        } else {
            loadCurrentUserProfile();
            setSnackBarMessage("Profile image updated.");
            setSnackBarOpen(true);
        }
        setUploading(false);
    };
    // Delete public profile handler
    const handleDeleteProfile = async () => {
        setDeleteDialogOpen(false);
        if (!currentUserProfile?.id) return;
        try {
            const res = await fetch(`${BACKEND_HOST}/user-profiles/${currentUserProfile.documentId}`, {
                method: "DELETE",
                headers: {
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                }
            });
            if (res.ok) {
                setSnackBarMessage("Public profile deleted.");
                setSnackBarOpen(true);
                loadCurrentUserProfile()
                // Optionally reload or update state/UI here
            } else {
                setSnackBarMessage("Failed to delete public profile.");
                setSnackBarOpen(true);
            }
        } catch (err) {
            setSnackBarMessage("Error deleting public profile.");
            setSnackBarOpen(true);
        }
    };

    // Handler to create profile
    const handleCreateProfile = async () => {
        setCreatingProfile(true);
        try {
            const res = await fetch(`${BACKEND_HOST}/user-profiles`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                },
                body: JSON.stringify({data: {
                    name: newProfile.name,
                    instagram: newProfile.instagram
                }})
            });
            if (res.ok) {
                setSnackBarMessage("Public profile created.");
                setSnackBarOpen(true);
                setCreateProfileDialogOpen(false);
                setNewProfile({ name: "", instagram: "" });
                if (typeof loadCurrentUserProfile === "function") loadCurrentUserProfile();
            } else {
                setSnackBarMessage("Failed to create public profile.");
                setSnackBarOpen(true);
            }
        } catch (err) {
            setSnackBarMessage("Error creating public profile.");
            setSnackBarOpen(true);
        }
        setCreatingProfile(false);
    };
   
    // Handler to re-send confirmation email
    const handleResendConfirmation = async () => {
        setConfirmLoading(true);
        setConfirmError(null);
        try {
            const res = await fetch(`${BACKEND_HOST}/auth/send-email-confirmation`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                },
                body: JSON.stringify({ email: user.email })
            });
            if (res.ok) {
                setSnackBarMessage("Confirmation email sent.");
                setSnackBarOpen(true);
            } else {
                setConfirmError("Failed to send confirmation email.");
            }
        } catch (err) {
            setConfirmError("Error sending confirmation email.");
        }
        setConfirmLoading(false);
    };

    const handleSaveBio = async () => {
        setBioSaving(true);
        try {
            await fetch(`${BACKEND_HOST}/user-profiles/${currentUserProfile.documentId}`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${window.localStorage.getItem("authToken")}`
                },
                body: JSON.stringify({ data: { bio } })
            });
            setSnackBarMessage("Bio updated successfully.");
            setSnackBarOpen(true);
            setEditBioDialogOpen(false);
            if (typeof loadCurrentUserProfile === "function") loadCurrentUserProfile();
        } catch (err) {
            setSnackBarMessage("Failed to update bio.");
            setSnackBarOpen(true);
        }
        setBioSaving(false);
    };

    if (!loggedIn) {
        return <div>Must be logged in for this page</div>
    }

    const iCalURL = calendarURL(BACKEND_HOST, token);

    return <Box>
        <Snackbar 
            open={snackBarOpen}
            message={snackBarMessage}
            onClose={() => setSnackBarOpen(false)}
            autoHideDuration={2500}
        />
        <Crumbs crumbs={[
            {title: "Account"}
        ]} />
        <AccountVsProfile open={accountVsProfileOpen} onClose={() => setAccountVsProfileOpen(false)} />
        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <Card style={{height: "100%"}}>
                    <CardHeader title={"Account Info"} />
                    <CardContent>
                        <Typography variant="body2" color="textSecondary" gutterBottom>Private Information</Typography>
                        <Box m={2} py={1}>
                            <Grid container alignItems="center">
                                <Grid item xs={3}>
                                    email:
                                </Grid>
                                <Grid item xs={9} display="flex" alignItems="center">
                                    {user.email}
                                    {user.confirmed ? (
                                        <Box ml={1} display="flex" alignItems="center" color="success.main">
                                            <CheckCircleIcon fontSize="small" />
                                            <Typography variant="caption" color="success.main" ml={0.5}>Confirmed</Typography>
                                        </Box>
                                    ) : (
                                        <Box ml={1} display="flex" alignItems="center" color="warning.main">
                                            <ErrorOutlineIcon fontSize="small" />
                                            <Typography variant="caption" color="warning.main" ml={0.5}>Not Confirmed</Typography>
                                        </Box>
                                    )}
                                </Grid>
                                {!user.confirmed && <Grid item xs={12}>   
                                    <Box mt={3}>                     
                                        <Button
                                            fullWidth
                                            size="small"
                                            variant="outlined"
                                            sx={{ ml: 1 }}
                                            onClick={handleResendConfirmation}
                                            disabled={confirmLoading}>
                                            {confirmLoading ? "Sending..." : "Resend Confirmation"}
                                        </Button>
                                    </Box>
                                </Grid>}
                            </Grid>
                            {confirmError && (
                                <Typography color="error" variant="caption">{confirmError}</Typography>
                            )}
                        </Box>
                        <Typography variant="body2" color="textSecondary" gutterBottom>Your email is always private and will not be displayed or shared.</Typography>
                        <Typography variant="body2" color="textSecondary" gutterBottom>Email is used only for transactional purposes such as password resets and, if you create content, notificiations about your content.</Typography>
                        <CardActionArea>
                            <Box mt={4} style={{textAlign: "center"}}>
                                <Button size="small" href={"/privacy"}>Privacy Policy</Button>
                            </Box>
                        </CardActionArea>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>

                {currentUserProfile === null && <Card sx={{ height: "100%" }}>
                    <CardHeader title={"Public Profile"} />
                    <CardContent>
                        <Typography variant={"body2"} color="textSecondary" gutterBottom>
                            You do not have a public profile yet. You can add content, but it will show as anonymous.
                        </Typography>
                        <Typography variant={"body2"} color="textSecondary" gutterBottom>
                            To create a public profile, click the button below.
                        </Typography>
                        <Box pt={2} sx={{textAlign: "center"}}>
                            <Link component="button" variant="body2" onClick={() => setAccountVsProfileOpen(true)}>
                                What is a public profile?
                            </Link>
                        </Box>
                        <Box pt={5} sx={{textAlign: "center"}}>
                            <Button 
                                variant={"outlined"}
                                onClick={() => setCreateProfileDialogOpen(true)}>Create Public Profile</Button>
                        </Box>
                    </CardContent>
                </Card>}
                {currentUserProfile !== null && <Card>
                    <CardHeader title={"Public Profile"} />
                    <CardContent>
                        <Box mb={2}>
                            <Typography variant={"body2"} color="textSecondary" gutterBottom>
                                This is your public profile. Information you choose to share here will be visible to other users.
                            </Typography>
                            <Link component="button" variant="body2" onClick={() => setAccountVsProfileOpen(true)}>
                                What is a public profile?
                            </Link>
                        </Box>
                        <Box mb={2} display="flex" flexDirection="column" alignItems="center">
                            {currentUserProfile?.pic?.formats?.thumbnail?.url ? (
                                <img
                                    src={currentUserProfile?.pic?.formats?.thumbnail?.url}
                                    alt="Profile"
                                    style={{ width: 96, height: 96, borderRadius: "50%", objectFit: "cover", marginBottom: 8 }}
                                />
                            ) : (
                                <Box
                                    sx={{
                                        width: 96,
                                        height: 96,
                                        borderRadius: "50%",
                                        bgcolor: "#eee",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        mb: 1
                                    }}
                                >
                                    <Typography variant="h4" color="textSecondary">?</Typography>
                                </Box>
                            )}
                            <Button
                                variant="outlined"
                                size="small"
                                component="label"
                                disabled={uploading}
                            >
                                {uploading ? "Uploading..." : "Upload Profile Image"}
                                <input
                                    type="file"
                                    accept="image/*"
                                    hidden
                                    ref={fileInputRef}
                                    onChange={handleImageChange}
                                />
                            </Button>
                            <Typography variant="caption" color="textSecondary" sx={{ mt: 1, textAlign: "center" }}>
                                Image should be less than 10MB and preferably square for best results.
                            </Typography>
                        </Box>
                        <Box>
                            <TextField
                                label="Instagram Name"
                                value={newProfileSettings.instagram}
                                onChange={e => updateProfile("instagram", e.target.value)}
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                helperText="Your Instagram handle without the @"
                            />
                            <TextField
                                label="Public Name"
                                value={newProfileSettings.name}
                                onChange={e => updateProfile("name", e.target.value)}
                                variant="outlined"
                                size="small"
                                fullWidth
                                margin="normal"
                                helperText="This is how your name will be displayed on your profile."
                            />
                        </Box>
                        <Box mt={2}>
                            <Typography variant="body2" color="textSecondary" gutterBottom>
                                <strong>Bio:</strong> {currentUserProfile?.bio ? currentUserProfile.bio : <span style={{color: "#888"}}>No bio yet.</span>}
                            </Typography>
                            <Button
                                variant="outlined"
                                size="small"
                                sx={{ mt: 1 }}
                                onClick={() => setEditBioDialogOpen(true)}
                            >
                                Edit Bio
                            </Button>
                        </Box>
                    </CardContent>
                    <CardActionArea>
                        <Box style={{textAlign: "right"}} m={2} display="flex" justifyContent="space-between" >
                            <Button size={"small"}
                                color="error"
                                onClick={() => setDeleteDialogOpen(true)}
                            >
                                Delete Public Profile
                            </Button>
                            <Button size="small" onClick={saveProfile} variant="contained" disabled={!profileChanged}>Update</Button>
                        </Box>
                    </CardActionArea>
                </Card>}
            </Grid>
            <Grid item xs={12} md={6}>
                <Card style={{height: "100%"}}>
                    <CardHeader title={"RSVP"} />
                    <CardContent>
                        <FormControl>
                          <Typography variant="body2" color="textSecondary" gutterBottom>Choose your preferred dance role. This is used to calculate lead / follow counts on the calendar when you click on a star on the Calendar.</Typography>
                          <RadioGroup value={settings.danceRole} onChange={e => updateSetting("danceRole", e.target.value)}>
                            <FormControlLabel value="lead" control={<Radio size="small" style={{paddingTop: "3px"}}/>} label="Lead" />
                            <FormControlLabel value="follow" control={<Radio size="small" style={{paddingTop: "3px"}}/>} label="Follow" />
                            <FormControlLabel value="other" control={<Radio size="small" style={{paddingTop: "3px"}}/>} label="Both / Other" />
                          </RadioGroup>
                        </FormControl>
                    </CardContent>
                </Card>
            </Grid>
            <Grid item xs={12} md={6}>
                <Card>
                    <CardHeader title={"Calendar Integration"} />
                    <CardContent>
                        <Typography variant={"body2"}>Wanna see all of your starred events on your favorite calendar app? Paste the link below into your app's calendar settings.</Typography>
                        <Alert severity={"warning"} icon={false}>
                            <AlertTitle>Privacy Warning</AlertTitle>
                            <Typography variant={"body2"}><em>Anyone with this link can see all of the events you have added a star to. Do not share.</em></Typography>
                        </Alert>
                        {validate(token) && <pre>{iCalURL}</pre>}
                        {token === null && <pre>Generating Link</pre>}
                        {token === false && <pre>Unable to generate Link</pre>}
                        <CardActionArea>
                            <Box style={{textAlign: "right"}} m={2}>
                                <Button variant={"contained"} disabled={!validate(token)} onClick={(e) => {copyToClipboard(e, iCalURL);setSnackBarMessage("Copied to Clipboard"); setSnackBarOpen(true);}}>Copy Link</Button>
                            </Box>
                        </CardActionArea>
                        <Alert severity={"info"} icon={false}>
                            <AlertTitle>Pro Tip</AlertTitle>
                            <Typography variant={"body2"}><em>It's important to paste the link directly into your calendar app, if you open this link and add the resulting downloaded (.ics) calender file, your calendar will not receive updates.</em></Typography>
                        </Alert>
                    </CardContent>
                </Card>
            </Grid>
        </Grid>
        {/* Delete confirmation dialog */}
        <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
            <DialogTitle>Delete Public Profile?</DialogTitle>
            <DialogContent>
                <Typography>Are you sure you want to delete your public profile? This cannot be undone.</Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setDeleteDialogOpen(false)}>Cancel</Button>
                <Button onClick={handleDeleteProfile} color="error" variant="contained">Delete</Button>
            </DialogActions>
        </Dialog>
        {/* Create profile dialog */}
        <Dialog open={createProfileDialogOpen} onClose={() => setCreateProfileDialogOpen(false)}>
            <DialogTitle>Create Public Profile</DialogTitle>
            <DialogContent>
                <TextField
                    label="Public Name"
                    value={newProfile.name}
                    onChange={e => setNewProfile(prev => ({ ...prev, name: e.target.value }))}
                    fullWidth
                    margin="normal"
                    helperText="Your public name will be displayed on your profile and posts."
                />
                <TextField
                    label="Instagram Name"
                    value={newProfile.instagram}
                    onChange={e => setNewProfile(prev => ({ ...prev, instagram: e.target.value }))}
                    fullWidth
                    margin="normal"
                    helperText="Your Instagram name will be displayed on your profile."
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setCreateProfileDialogOpen(false)}>Cancel</Button>
                <Button
                    onClick={handleCreateProfile}
                    variant="contained"
                    disabled={creatingProfile || !newProfile.name}
                >
                    Create
                </Button>
            </DialogActions>
        </Dialog>
        {/* Edit Bio Dialog */}
        <Dialog open={editBioDialogOpen} onClose={() => setEditBioDialogOpen(false)}>
            <DialogTitle>Edit Bio</DialogTitle>
            <DialogContent>
                <TextField
                    label="Bio"
                    value={bio}
                    onChange={e => {
                        if (e.target.value.length <= 250) setBio(e.target.value);
                    }}
                    fullWidth
                    multiline
                    minRows={3}
                    maxRows={8}
                    margin="normal"
                    helperText={`Share a little about yourself! This will be visible on your public profile. (${bio.length}/250)`}
                    inputProps={{ maxLength: 250 }}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={() => setEditBioDialogOpen(false)}>Cancel</Button>
                <Button
                    onClick={handleSaveBio}
                    variant="contained"
                    disabled={bioSaving}
                >
                    {bioSaving ? "Saving..." : "Save"}
                </Button>
            </DialogActions>
        </Dialog>
    </Box>
}

export {AccountPage}